import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import { plans } from 'redux-app/modules/subscriptions'
import { onSelectSubscriptionPlan } from 'redux-app/actionCreators/subscription'
import { getSubscriptionPlans } from 'redux-app/selectors/subscription'
import { isUserAuthorizated } from 'redux-app/selectors/auth'
import SelectPlan from './SelectPlan'
import { setScrollElementId } from 'redux-app/modules/pageScroller'
import { analytics } from 'services/Analytics'

export default compose(
  withLocalization('home.main.selectPlan'),
  connect(
    (state) => {

      const isUserLogin = isUserAuthorizated(state)
      const subscriptionPlans = getSubscriptionPlans(state)
      .sort((a, b) => {

        if (a.weight === b.weight) {
          return !!a.activationFee ? 1 : -1
        }

        return a.weight > b.weight ? 1 : -1
      })

      subscriptionPlans.forEach(plan => {
        if (typeof plan['visible'] == 'undefined') {
          plan['visible'] = false;
        }
      })

      const groupByCategory = subscriptionPlans.reduce((group, plan) => {
        group[plan.weight] = group[plan.weight] ?? []
        group[plan.weight].push(plan)
        return group
      }, {})

      for (const item in groupByCategory) {

        if (groupByCategory[item].length == 1) {
          groupByCategory[item][0].visible = true
        }
        else if (groupByCategory[item][0].visible == false && groupByCategory[item][1].visible == false) {
          groupByCategory[item][0].visible = true
        }
      }

      return {
        isUserLogin,
        subscriptionPlans,
        groupedPlans: groupByCategory,
      }
    },
    {
      onSelectSubscriptionPlan,
      setScrollElementId,
      plans,
    },
  ),
  withHandlers({
    onUpdatePlans: ({
      plans,
    }) => updatedPlans => {
      plans(updatedPlans)
    },
    onSelectPlan: ({ onSelectSubscriptionPlan, subscriptionPlans }) => planId => {
      onSelectSubscriptionPlan(planId)

      const newPlan = subscriptionPlans.find(plan => plan.id === planId)

      if (subscriptionPlans.some(plan => plan.id !== planId && newPlan.weight === plan.weight))
      {
        analytics.homeSelectPlan({activationFee : newPlan.activationFee})
      }
      else
      {
        analytics.homeSelectPlan({activationFee: null})
      }
    },
  }),
)(SelectPlan)
